/* global axios */
import ApiClient from './ApiClient';

class SupportAPI extends ApiClient {
  constructor() {
    super('support', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  sendMessage(content, attachment) {
    if (!attachment) {
      return axios.post(this.url, { message: { content } });
    }

    const formData = new FormData();
    formData.append('message[content]', content);
    formData.append('message[attachments][]', attachment);
    return axios.post(this.url, formData);
  }
}

export default new SupportAPI();
